import React, { useState } from 'react';
import '../../Stylesheets/Public/FooterWithNewsletter.css';
import Site360Logo from '../../assets/images/logo.png';

const FooterWithNewsletter = () => {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <footer className="lp-footer lp-footer-v2">
      <div className="page-container footer-v2-layout">
        {/* LEFT: brand */}
        <div className="footer-v2-brand">
          <div className="footer-v2-logoRow">
            {!logoFailed ? (
              <img
                src={Site360Logo}
                alt="Site360"
                className="footer-v2-logoImg"
                onError={() => setLogoFailed(true)}
              />
            ) : (
              <div className="footer-v2-logoMark" aria-hidden="true">S</div>
            )}

            <div className="footer-v2-brandText">
              <div className="footer-v2-brandName">Site360</div>
              <div className="footer-v2-brandTag">Construction ops, finally organized.</div>
            </div>
          </div>

          <p className="footer-v2-desc">
            Track labor, materials, expenses, and site progress in one dashboard — built for real on-site teams.
          </p>

          <div className="footer-v2-social">
            <a className="footer-v2-socialBtn" href="#" onClick={(e) => e.preventDefault()}>🌐 Website</a>
            <a className="footer-v2-socialBtn" href="#" onClick={(e) => e.preventDefault()}>💬 WhatsApp</a>
            <a className="footer-v2-socialBtn" href="#" onClick={(e) => e.preventDefault()}>✉️ Email</a>
          </div>
        </div>

        {/* RIGHT: columns */}
        <div className="footer-v2-cols">
          {/* ... keep your columns same ... */}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-v2-bottom">
        <div className="page-container footer-v2-bottomRow">
          <div className="footer-v2-copy">
            © {new Date().getFullYear()} Site360. All rights reserved.
          </div>

          <div className="footer-v2-legal">
            <a href="#" onClick={(e) => e.preventDefault()} className="footer-v2-legalLink">Privacy</a>
            <span className="footer-v2-dot">•</span>
            <a href="#" onClick={(e) => e.preventDefault()} className="footer-v2-legalLink">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterWithNewsletter;
